import React from 'react';
import styles from './SiteTag.module.css';

export interface SiteTagProps {
    label: string;
    variant?: 'compact' | 'default';
    className?: string;
}

const SiteTag: React.FC<SiteTagProps> = ({ label, variant = 'default', className }) => {
    const sizeClass = variant === 'compact' ? styles.compact : styles.default;
    const combined = [styles.pill, sizeClass, className].filter(Boolean).join(' ');
    return <span className={combined}>{label}</span>;
};

export default SiteTag;
